import { createContext, useContext } from 'react'
import type { Campaign } from '@/lib/campaigns'

export interface MetaConversionsLayoutContextValue {
  campaignId: number | null
  campaignValue: string
  selectedCampaign: Campaign | null
  setCampaignValue: (value: string) => void
  campaignsLoading: boolean
  hasCampaigns: boolean
  isAdminWithoutInstitution: boolean
}

const MetaConversionsLayoutContext = createContext<MetaConversionsLayoutContextValue | undefined>(undefined)

// eslint-disable-next-line react-refresh/only-export-components -- hook exportado junto ao provider (padrão de contexto)
export function useMetaConversionsLayout(): MetaConversionsLayoutContextValue {
  const context = useContext(MetaConversionsLayoutContext)
  if (!context) {
    throw new Error('useMetaConversionsLayout must be used within MetaConversionsLayoutContext.Provider')
  }

  return context
}

export const MetaConversionsLayoutContextProvider = MetaConversionsLayoutContext.Provider
